export const MEDIA_API = {
  FOOTBALL_SCHEDULE: '/football-schedule',
  FOOTBALL_SCHEDULE_FIXTURE: '/media/hot-match/fixture',
  HOT_MATCH: '/media/hot-match',
}
